import React, {useState} from 'react';
import { Link } from 'react-router-dom';


function Footer(props) {




  return (
    <div class="container">
        <footer class="py-3 my-4">
            <ul class="nav justify-content-center border-bottom pb-3 mb-3">
            <li class="nav-item"><Link to="/Services" class="nav-link px-2 text-body-secondary">Services</Link></li>
            <li class="nav-item"><Link to="/Responsibilities" class="nav-link px-2 text-body-secondary">Responsibilities</Link></li>
            <li class="nav-item"><Link to="/Deployments" class="nav-link px-2 text-body-secondary">Deployments</Link></li>
            <li class="nav-item"><Link to="/TimestampGenerator" class="nav-link px-2 text-body-secondary">Timestamps</Link></li>
            <li class="nav-item"><Link to="/Legal" class="nav-link px-2 text-body-secondary">Legal</Link></li>
            </ul>
            <i><p class="text-center text-body-secondary">Created by Noay_HD1</p></i>
        </footer>
    </div>
    
  );
}

export default Footer;